// extracted by mini-css-extract-plugin
module.exports = {"btn-in-mobile":"main_btn-in-mobile__gDPBf","form-container":"main_form-container__ZsP5i","confirm-cover":"main_confirm-cover__1wqMc"};